<template>
  <div class="address">
    <div class="head">
      <el-button size="small" type="primary" @click="editItem(params)"><i class="el-icon-circle-plus"></i> {{ pc_lang['AddAddress'] }}</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      align="center"
      class="addressList"
      style="width: 100%">
      <el-table-column
        prop="name"
        :label="pc_lang['Name']"
        width="150">
        <template slot-scope="scope">
          {{ `${scope.row.first_name} ${scope.row.last_name}` }}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="pc_lang['Address']">
        <template slot-scope="scope">
          {{ `${scope.row.country} ${scope.row.province} ${scope.row.city} ${scope.row.address} ${scope.row.zip}` }}
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        :label="pc_lang['Tel']"
        width="160">
        <template slot-scope="scope">
          {{ `${scope.row.gr} ${scope.row.mobile}` }}
        </template>
      </el-table-column>
      <el-table-column
        :label="pc_lang['Operation']"
        width="200">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row.addr_id)">删除</el-button>
          <el-button type="text" size="small" class="isDefault" v-if="!!scope.row.is_default">默认</el-button>
          <el-button type="text" size="small" @click="setDefault(scope.row)" v-else>设为默认</el-button>
        </template>
      </el-table-column>
      <!-- 暂无数据 -->
      <div slot="empty">
        {{ pc_lang['No_more_data'] }}
      </div>
    </el-table>

    <AddressPop :addressPopBoolean="addressPopBoolean" :params="propsParams" @submit="submit"/>
  </div>
</template>

<script>
// @ is an alias to /src
import * as API_ADDRESS from '@/api/address'
import AddressPop from '@/components/user/AddressPop'

export default {
  name: 'UserAddress',
  components: {
    AddressPop
  },
  data() {
    return {
      // 地址信息
      params: {
        first_name: '',
        last_name: '',
        country: '',
        province: '',
        city: '',
        address: '',
        zip: '',
        gr: '',
        mobile: '',
        email: '',
        is_default: '',
        addr_id: ''
      },
      defaultParams: {
        first_name: '',
        last_name: '',
        country: '',
        province: '',
        city: '',
        address: '',
        zip: '',
        gr: '',
        mobile: '',
        email: '',
        is_default: '',
        addr_id: ''
      },
      propsParams: {},

      // 地址列表数据
      tableData: [],

      addressPopBoolean: false
    }
  },
  watch: {
    addressPopBoolean(val, oldVal) {
      if (!val) {
        this.resetPramas()
      }
    }
  },
  computed: {

  },
  async mounted() {

  },
  created() {
    this.getList()
    // this.add()
  },
  methods: {
    resetPramas() {
      this.params = this.defaultParams
      this.propsParams = {}
    },
    getList() {
      API_ADDRESS.getAddressList().then(res=> {
        const { data } = res
        this.tableData = data
      })
    },
    add(params) {
      API_ADDRESS.addAddress(params).then(res=> {
        this.resetPramas()
        this.getList()
      })
    },
    edit(params) {
      API_ADDRESS.editAddress(params).then(res=> {
        this.resetPramas()
        this.getList()
      })
    },
    editItem(params) {
      this.propsParams = JSON.parse(JSON.stringify(params))
      this.addressPopBoolean = true
    },
    deleteItem(ids) {
      API_ADDRESS.deleteAddress(ids).then(res=> {
        this.getList()
      })
    },
    setDefault(params) {
      params.is_default = 1
      this.edit(params)
    },
    submit(params) {
      // if (!!params.addr_id) {
      //   this.edit(params)
      // } else {
      //   this.add(params)
      // }
      this.resetPramas()
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.address{
  // margin: 10px;
  .head{
    padding: 8px 0;
    text-align: right;
  }
  .addressList{
    border-top: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
  }
  .isDefault{
    color: orange;
  }
}
</style>